import { render, staticRenderFns } from "./FetchWaybill.vue?vue&type=template&id=990a2d6a&scoped=true&"
import script from "./FetchWaybill.vue?vue&type=script&lang=js&"
export * from "./FetchWaybill.vue?vue&type=script&lang=js&"
import style0 from "./FetchWaybill.vue?vue&type=style&index=0&id=990a2d6a&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "990a2d6a",
  null
  
)

export default component.exports